import { Box, Link } from "@modernatx-internal/ui-kit-react";
import React from "react";

const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
const urlRegex = /(https?:\/\/[^\s]+\.com\b|(?:www\.)?[^\s]+\.com\b)/;
const combinedRegex = new RegExp(`${emailRegex.source}|${urlRegex.source}`, "g");

export const RichText: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: () => "1em"
      }}
    >
      {text.split(/\n+/).map((textPart, i) => (
        <Box as="p" key={i}>
          {textPart.split(combinedRegex).map((part, j) => {
            if (!part) {
              return null;
            }

            if (emailRegex.test(part)) {
              return (
                <Link key={j} href={`mailto:${part}`}>
                  {part}
                </Link>
              );
            } else if (urlRegex.test(part)) {
              const href = part.startsWith("http") ? part : `https://${part}`;

              return (
                <Link key={j} href={href}>
                  {part}
                </Link>
              );
            } else {
              return <React.Fragment key={j}>{part}</React.Fragment>;
            }
          })}
        </Box>
      ))}
    </Box>
  );
};
